export default {
      id: "vibe-usage",
      viewBox: "0 0 226.31 63.78",
      url: "../../assets/" + "sprite.svg#vibe-usage",
      toString: function () {
        return this.url;
      }
    }